import React, { useState, useEffect } from 'react'
import { Table } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import './styles.scss'
import DKVConfiguration from 'constants/dkv.constants'
import Checkbox from 'components/Checkbox'

const valuesToShow = [
  'fullName', 'phone',
  ...DKVConfiguration.isDKV ? ['codcliente'] : [],
  'occasion_id', 'occasion_name'
]

const ExcelTable = ({ users, selectedExcelUsers }) => {
  const data = users
  const headers = Object.keys(data[0])

  const [selectAll, setSelectAll] = useState(false)
  const [selectedUsers, setSelectedUsers] = useState(data)

  useEffect(() => {
    selectedExcelUsers(selectedUsers)
  }, [selectedUsers, selectedExcelUsers])

  const tableHeaders = (headers) => {
    const newHeaders = ['fullName'].concat(headers.filter(header => valuesToShow.includes(header) ))
    return newHeaders.map((header, index) => <th key={index}>{header === 'fullName' ? I18n.t('dashboard_full-name') : I18n.t(header)}</th>)
  }

  const onSelectAll = () => {
    setSelectedUsers(data)
    setSelectAll((selected) => !selected)
  }

  const handleCheckbox = (rowId) => {
    const user = data[rowId]
    const userIndex = selectedUsers.indexOf(user)

    if (userIndex !== -1) {
      const newSelectedUsers = [...selectedUsers]
      newSelectedUsers.splice(userIndex, 1)
      setSelectedUsers(newSelectedUsers)
      if (selectAll) {
        setSelectAll(false)
      }
    } else {
      const newSelectedUsers = [].concat(selectedUsers)
      newSelectedUsers.splice(rowId, 0, user)
      setSelectedUsers(newSelectedUsers)
      if (selectAll) {
        setSelectAll(false)
      }
    }
  }

  const renderTableBody = (data) => {
    const dataCopy = [...data]
    return dataCopy.map((row, index) => {
      const fullName = `${row.name || ''} ${row.lastName || ''}`.trim()

      const newRow = {
        fullName,
      }
      Object.keys(row).forEach((key) => {
        if (key !== 'name' && key !== 'lastName') {
          newRow[key] = row[key]
        }
      })

      const checked = selectedUsers.indexOf(row) !== -1 ? true : false

      return (
        <tr key={index} id={index}>
          <td>
            <Checkbox
              className='excell-check-box'
              id={`check-${index}`}
              type='checkbox'
              onChange={() => handleCheckbox(index)}
              value='true'
              checked={checked}
            />
          </td>
          {
            Object.keys(newRow).filter(key => valuesToShow.includes(key)).map((key, index) => (
              <td key={`${newRow[key]}-${index}`}>{newRow[key] || ''}</td>
            ))
          }
        </tr>
      )
    })
  }

  return (
    <div>
      <Table id='exceltable' hover responsive className='table-recipients'>
        <thead>
          <tr>
            <th>
              <Checkbox
                className='excell-check-box'
                id='exceltable-check'
                type='checkbox'
                onChange={onSelectAll}
                value='true'
                checked={selectAll}
              />
            </th>
            {tableHeaders(headers)}
          </tr>
        </thead>
        <tbody>{renderTableBody(data)}</tbody>
      </Table>
    </div>
  )
}

export default ExcelTable
